<section
    class="blog-area ptb-100"
    [class.dark-blog-area]="themeService.isDark()"
>
    <div class="container">
        <div class="section-title text-center">
            <span class="sub-title" i18n>Our Recent Projects</span>
            <h2 i18n>View Our Recent Projects</h2>
            <a routerLink="/projects/" class="default-btn"><i class='bx bx-show-alt icon-arrow before'></i><span class="label" i18n>View All</span><i class="bx bx-show-alt icon-arrow after"></i></a>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6" *ngFor="let project of projects">
                <div class="single-blog-post-card mb-30">
                    <div class="post-image">
                        <a routerLink="/projects/{{project.id}}" class="d-block">
                            <img src="{{imageURL + project.picture}}" style="max-height:22rem" alt="image">
                        </a>
                    </div>
                    <div class="post-content">
                        <div class="tag">
                            <a>{{project.project_category.category_name}}</a>
                        </div>
                        <ul class="post-meta">
                            <li class="post-author">
                                <span i18n>Location:</span><a routerLink="" class="d-inline-block">{{project.location}}</a>
                            </li>
                            <li class="date"><i class='bx bxs-calendar'></i> <span>{{project.start_date|date:"longDate"}}</span> - <span>{{project.end_date|date:"longDate"}}</span></li>
                        </ul>
                        <h3><a routerLink="/projects/{{project.id}}" class="d-inline-block">{{project.name}}</a></h3>
                        <a routerLink="/projects/{{project.id}}" class="read-more-btn" i18n>Read More</a>
                    </div>
                </div>
            </div>
            
            
        </div>
    </div>
</section>